import { useState } from "react";
import { BeatShell, ChipRow } from "@/components/nutrition/NutritionParts";
import { gradeChips, beatMax, ICON_BY_TYPE } from "../beatUtils";
import { Briefing } from "./Shared";

export function MultiBeat({ beat, eyebrow, showBriefing, c, accent, onDone }) {
  const [sel, setSel] = useState(new Set());
  const [res, setRes] = useState(null);
  const checked = !!res;
  const Icon = beat.icon || ICON_BY_TYPE.multi;
  const toggle = (i) => { const n = new Set(sel); n.has(i) ? n.delete(i) : n.add(i); setSel(n); };
  const onPrimary = () => {
    if (!checked) {
      const g = gradeChips(beat.chips, sel, beat.max ?? 20);
      setRes({ earned: g.pts, max: beatMax(beat), detail: `Caught ${g.caught}/${g.total}, ${g.falseTaps} false`, key: beat.key, label: beat.label });
    } else onDone(res);
  };
  return (
    <BeatShell Icon={Icon} eyebrow={eyebrow} title={beat.title} subtitle={beat.prompt}
      primaryLabel={checked ? beat.last ? "See debrief →" : "Continue →" : "Check answers"} onPrimary={onPrimary} primaryTestId={`${beat.key}-primary-btn`} accent={accent}>
      {showBriefing && <Briefing c={c} />}
      <ChipRow chips={beat.chips} selected={sel} onToggle={toggle} revealed={checked} testidPrefix={`${beat.key}-chip`} />
      {checked && (
        <div className="mt-1 space-y-1.5" data-testid={`${beat.key}-coaching`}>
          {beat.chips.filter((x) => x.flag).map((x, i) => (
            <div key={i} className="text-[11px] text-slate-600 leading-snug">
              <span className="text-emerald-600 font-semibold">⚑ {x.t}:</span> {x.coach}
            </div>
          ))}
        </div>
      )}
    </BeatShell>
  );
}
